<template>
  <div>
    <div
      class="uni_suggestion pointer f13"
      data-toggle="dropdown"
      role="button"
      aria-haspopup="true"
      aria-expanded="false"
    >
      <b>{{ doc_count }}</b> {{ key_name }}
    </div>
    <div class="dropdown-menu">
      <div class="dropdown-item pointer">
        <p @click="setRequired" class="mt-0 mb-0">Requerido</p>
      </div>
      <div class="dropdown-item pointer">
        <p @click="setOptionals" class="mt-0 mb-0">Opcional</p>
      </div>
      <div class="dropdown-item pointer">
        <p @click="setExcluded" class="mt-0 mb-0">Excluir</p>
      </div>
    </div>
  </div>
</template>

<script>
import { state, gettersMap, mutationsMap } from "store/table.js";
import { compareDesc } from "date-fns/fp";
export default {
  props: ["key_name", "doc_count"],
  methods: {
    setRequired() {
      let term = gettersMap.getTermsRequireds().map((term) => term);
      term.push(this.key_name);
      mutationsMap.setTermsRequired(term);
      this.$emit("populationTerms", [this.key_name], "terms_requireds");
    },
    setOptionals() {
      let term = gettersMap.getTermsOptionals().map((term) => term);
      term.push(this.key_name);
      mutationsMap.setTermsOptionals(term);
      this.$emit("populationTerms", [this.key_name], "terms_optionals");
    },
    setExcluded() {
      let term = gettersMap.getTermsExcluded().map((term) => term);
      term.push(this.key_name);
      mutationsMap.setTermsExcluded(term);
      this.$emit("populationTerms", [this.key_name], "terms_excluded");
    },
  },
};
</script>
